import { render, staticRenderFns } from "./AdArtistSearch.vue?vue&type=template&id=5009655b&scoped=true"
import script from "./AdArtistSearch.vue?vue&type=script&lang=js"
export * from "./AdArtistSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5009655b",
  null
  
)

export default component.exports